// Journal numbers as the server builds them (app/modules/records/journals.py):
// {seq} ({seq:4} zero-pads), {year}, {yy}, {case}. Used for the live preview
// in the journal form; the server's number is the one that counts.

const TOKEN = /\{([^{}]*)\}/g;
const SEQ = /^seq(?::([1-9]))?$/;

export const REGISTER_KINDS = ['incoming', 'outgoing', 'internal', 'orders', 'other'];

// The longest number a pattern can make must fit the server's 80 characters:
// {case} up to 32, {seq} up to ten digits ({seq:N} at least N), {year} 4, {yy} 2.
export const PATTERN_MAX = 64;
export const NUMBER_MAX = 80;
const WIDEST = { year: 4, yy: 2, case: 32 };

export function widestNumber(pattern) {
  const text = pattern || '';
  const tokens = [...text.matchAll(TOKEN)].map((m) => m[1]);
  const literal = text.replace(TOKEN, '').length;
  return literal + tokens.reduce((sum, name) => {
    const seq = SEQ.exec(name);
    return sum + (seq ? Math.max(10, Number(seq[1] || 0)) : (WIDEST[name] ?? name.length + 2));
  }, 0);
}

export function patternProblem(pattern) {
  const text = (pattern || '').trim();
  if (!text) return 'empty';
  const tokens = [...text.matchAll(TOKEN)].map((m) => m[1]);
  const opens = (text.match(/\{/g) || []).length;
  const closes = (text.match(/\}/g) || []).length;
  if (opens !== tokens.length || closes !== tokens.length) return 'broken';
  if (tokens.some((t) => !['year', 'yy', 'case'].includes(t) && !SEQ.test(t))) return 'unknown';
  if (!tokens.some((t) => SEQ.test(t))) return 'no_seq';
  if (text.length > PATTERN_MAX || widestNumber(text) > NUMBER_MAX) return 'too_long';
  return null;
}

export function formatNumber(pattern, { seq, year, caseIndex = null }) {
  return (pattern || '').replace(TOKEN, (whole, name) => {
    const seqMatch = SEQ.exec(name);
    if (seqMatch) return String(seq).padStart(Number(seqMatch[1] || 0), '0');
    if (name === 'year') return String(year);
    if (name === 'yy') return String(year % 100).padStart(2, '0');
    if (name === 'case') return caseIndex ?? '{case}';
    return whole;
  });
}

// Today in the records time zone (the server's RECORDS_TIMEZONE), as YYYY-MM-DD.
export function todayInTashkent(now = new Date()) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Tashkent', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
}

// DD.MM.YYYY from YYYY-MM-DD without going through Date (no time-zone shift).
export function fmtDay(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return d && m && y ? `${d}.${m}.${y}` : String(iso);
}
